
// EVALUATIONs
export const GET_EVALUATIONS = "/evaluations";
export const ADD_NEW_EVALUATION = "/evaluations";
export const UPDATE_EVALUATION = "/evaluations";
export const DELETE_EVALUATION = "/evaluations";

// Moyennes par évaluation
export const GET_AVERAGE_BY_EVALUATION = (evaluationUuid) => `/evaluations/${evaluationUuid}/average`;


